import { Component, ChangeDetectionStrategy, Input, ViewEncapsulation, HostBinding, OnInit } from '@angular/core';
import { TestCarModel } from '@modules/card/models/test-car.model';
import { Screen } from '@modules/shared/services/window.service';
import {
  RibbonSliderFilterInterface,
  RibbonSliderNavigationConfigInterface,
} from '@modules/slider/interfaces/ribbon-slider.interface';
import { TEST_CAR_PAGE_RIBBON_SLIDER_CONFIG } from '@pages/test-car-page/configs/test-car-page-ribbon-slider.config';

@Component({
  selector: 'mb-test-car-section',
  templateUrl: './test-car-section.component.html',
  styleUrls: ['./test-car-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class TestCarSectionComponent implements OnInit {
  public activeFilter?: RibbonSliderFilterInterface;

  public placeholderOffsetItemClasses = ['d-none', 'd-md-block', 'col-md-4', 'col-lg-3'];
  public config: RibbonSliderNavigationConfigInterface = {
    showNavigation: true,
    navigationCap: 0,
    itemsToShow: 1,
    breakpoints: {
      [Screen.XS]: {
        showNavigation: true,
        navigationCap: 1,
        itemsToShow: 2,
      },
      [Screen.MD]: {
        showNavigation: true,
        navigationCap: 2,
        itemsToShow: 2,
      },
      [Screen.LG]: {
        showNavigation: true,
        navigationCap: 2,
        itemsToShow: 3,
      },
    },
  };
  public activeTeasers: TestCarModel[] = [];
  private _items: TestCarModel[] = [];

  @Input() sectionId?: string;

  @Input() headline: string = '';
  @Input() anchor: string = '';

  @HostBinding('class.sticky-filters')
  @Input()
  stickyFilters = true;

  @Input()
  set items(v: TestCarModel[]) {
    this._items = v;
    this.filter(this.activeFilter);
  }
  get items() {
    return this._items;
  }

  private _filters: RibbonSliderFilterInterface[] = [];
  @Input()
  set filters(_filters: RibbonSliderFilterInterface[]) {
    this._filters = _filters;
    this.activeFilter = _filters[0];
  }
  get filters() {
    return this._filters;
  }

  public filter(filter?: RibbonSliderFilterInterface) {
    this.filters.forEach((_filter) => {
      _filter.active = false;
    });
    if (!filter || filter.value === 'ALL') {
      this.activeTeasers = this._items;
      if (filter) {
        filter.active = true;
      }
      return;
    }
    this.activeFilter = filter;
    filter.active = true;
    this.activeTeasers = this._items.filter((teaser) => teaser.filter.value === filter.value);
  }

  ngOnInit() {
    if (!this.filters.length) {
      this.placeholderOffsetItemClasses = ['d-none'];
      this.config = TEST_CAR_PAGE_RIBBON_SLIDER_CONFIG;
      this.stickyFilters = false;
    }
  }
}
